<script setup lang="ts">
const props = defineProps({
  speed: {
    default: 50,
    type: Number,
  },
  startDelay: {
    default: 0,
    type: Number,
  },
  text: {
    required: true,
    type: String,
  },
})

const displayedText = defineModel<string>({
  default: '',
  required: false,
})

const typingAnimation = shallowRef<null | ReturnType<typeof useRafInterval>>(null)
const characterIndex = ref(0)

onMounted(() => {
  if (import.meta.client) {
    triggerTypewriter()
  }
})

watch(() => props.text, triggerTypewriter)

function triggerTypewriter() {
  displayedText.value = ''
  characterIndex.value = 0

  if (typingAnimation.value !== null) {
    typingAnimation.value.pause()
  }

  useRafTimeout(() => {
    typingAnimation.value = useRafInterval(() => {
      if (characterIndex.value < props.text.length) {
        displayedText.value += props.text[characterIndex.value]
        characterIndex.value++
      }
      else {
        if (typingAnimation.value !== null) {
          typingAnimation.value.pause()
          typingAnimation.value = null
        }
      }
    }, props.speed)
  }, props.startDelay, { immediate: true })
}
</script>

<template>
  <span>{{ displayedText }}</span>
</template>
